import { __decorate } from "tslib";
import * as React from 'react';
import classNames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import { observer } from 'mobx-react';
import Checkbox from '../../../lib/checkbox';
import Dropdown from '../dropdown';
import Menu from '../menu';
import Icon from '../icon';
function checkSelection({ store, getCheckboxPropsByItem, getRecordKey, data, type, byDefaultChecked, }) {
    return byDefaultChecked
        ? data[type]((item, i) => getCheckboxPropsByItem(item, i).defaultChecked)
        : data[type]((item, i) => store.selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0);
}
function getIndeterminateState(props) {
    const { store, data } = props;
    if (!data.length) {
        return false;
    }
    const someCheckedNotByDefaultChecked = checkSelection({
        ...props,
        data,
        type: 'some',
        byDefaultChecked: false,
    }) &&
        !checkSelection({
            ...props,
            data,
            type: 'every',
            byDefaultChecked: false,
        });
    const someCheckedByDefaultChecked = checkSelection({
        ...props,
        data,
        type: 'some',
        byDefaultChecked: true,
    }) &&
        !checkSelection({
            ...props,
            data,
            type: 'every',
            byDefaultChecked: true,
        });
    if (store.selectionDirty) {
        return someCheckedNotByDefaultChecked;
    }
    return someCheckedNotByDefaultChecked || someCheckedByDefaultChecked;
}
function getCheckState(props) {
    const { store, data } = props;
    if (!data.length) {
        return false;
    }
    if (store.selectionDirty) {
        return checkSelection({
            ...props,
            data,
            type: 'every',
            byDefaultChecked: false,
        });
    }
    return (checkSelection({
        ...props,
        data,
        type: 'every',
        byDefaultChecked: false,
    }) ||
        checkSelection({
            ...props,
            data,
            type: 'every',
            byDefaultChecked: true,
        }));
}
let SelectionCheckboxAll = class SelectionCheckboxAll extends React.Component {
    constructor(props) {
        super(props);
        this.handleSelectAllChange = (e) => {
            const { checked } = e.target;
            this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
        };
        this.defaultSelections = props.hideDefaultSelections
            ? []
            : [
                {
                    key: 'all',
                    text: 'SelectAll',
                },
                {
                    key: 'invert',
                    text: 'SelectInvert',
                },
            ];
    }
    setCheckState(props) {
        const checked = getCheckState(props);
        const indeterminate = getIndeterminateState(props);
        this.setState(prevState => {
            const newState = {};
            if (indeterminate !== prevState.indeterminate) {
                newState.indeterminate = indeterminate;
            }
            if (checked !== prevState.checked) {
                newState.checked = checked;
            }
            return newState;
        });
    }
    renderMenus(selections) {
        return selections.map((selection, index) => {
            return (React.createElement(Menu.Item, { key: selection.key || index },
                React.createElement("div", { onClick: () => {
                        this.props.onSelect(selection.key, index, selection.onSelect);
                    } }, selection.text)));
        });
    }
    render() {
        const { disabled, prefixCls, selections } = this.props;
        const checked = getCheckState(this.props);
        const indeterminate = getIndeterminateState(this.props);
        const selectionPrefixCls = `${prefixCls}-selection`;
        let customSelections = null;
        if (selections) {
            const newSelections = Array.isArray(selections)
                ? this.defaultSelections.concat(selections)
                : this.defaultSelections;
            const menu = (React.createElement(Menu, { className: `${selectionPrefixCls}-menu`, selectedKeys: [] }, this.renderMenus(newSelections)));
            customSelections =
                newSelections.length > 0 ? (React.createElement(Dropdown, { overlay: menu },
                    React.createElement("div", { className: `${selectionPrefixCls}-down` },
                        React.createElement(Icon, { type: "down" })))) : null;
        }
        return (React.createElement("div", { className: selectionPrefixCls },
            React.createElement(Checkbox, { className: classNames({ [`${selectionPrefixCls}-select-all-custom`]: customSelections }), checked: checked, indeterminate: indeterminate, disabled: disabled, onChange: this.handleSelectAllChange }),
            customSelections));
    }
};
SelectionCheckboxAll = __decorate([
    observer
], SelectionCheckboxAll);
polyfill(SelectionCheckboxAll);
export default SelectionCheckboxAll;
